import React from "react";
import { PolicyManagementRecord } from "entities/UIModel/PolicyManagementRecord";
import StatsBar, { StatsBarMetric } from "pages/utils/StatsBar";
import { formatCurrency } from "pages/utils/pageHelper";

export type PolicyStatsBarVariant = "qr" | "pcq" | "cq" | "history";

interface PolicyStatsBarProps {
  records: PolicyManagementRecord[];
  variant?: PolicyStatsBarVariant;
}

const PolicyStatsBar = ({ records, variant = "qr" }: PolicyStatsBarProps) => {
  // Whole-query aggregates the SP stamps on every row; read from the first row.
  const first = records[0];
  const num = (v: number | null | undefined) => (v ?? 0).toLocaleString();
  const cur = (v: number | null | undefined) => formatCurrency(v ?? 0);

  const isHistory = variant === "history";

  const metrics: StatsBarMetric[] = [
    { label: "Products", value: num(first?.TotalProducts) },
    { label: "Open Errors", value: num(first?.TotalOpenErrors) },
    { label: "SI", value: num(first?.TotalSimultaneous) },
    { label: "Liability", value: cur(first?.TotalLiabilityAmount) },
    { label: "Premium/Fee", value: cur(first?.TotalActualFee) },
    { label: "UW Remittance", value: cur(first?.TotalActualRemittance) },
    { label: "States", value: num(first?.TotalStates) },
  ];

  return (
    <StatsBar
      // "All Results" only on Quality Review / Pre-Close / Close Queue.
      highlight={
        isHistory
          ? undefined
          : { label: "All Results", value: num(first?.TotalCount) }
      }
      metrics={metrics}
    />
  );
};

export default PolicyStatsBar;
